import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection } from '@components'
import { PromotionAPI, BannerAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { CarouselAds } from '../Home/Components'
import PromotionCard from '../../common/components/PromotionCard'
import moment from 'moment'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const InvestorContainer = styled.div`
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    margin-top: 5px;
  }
`

const PromoContainer = styled.div`
  background-color: #f9f9f9;
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Desktop = styled.div`
  display: none;
  height: 100%;
  padding-bottom: 40px;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const InputTextWrapper = styled.div`
  box-shadow: rgb(0 0 0 / 5%) 0px -1px 2px, rgb(0 0 0 / 10%) 0px 2px 4px;
  border-radius: 6px;
  background-color: rgb(255, 255, 255) !important;
  margin-bottom: 10px;
`

const InputTextIcon = styled.div`
  border-right: 0px !important;
  background-color: rgb(255, 255, 255) !important;
`

const InputText = styled.input`
  margin-bottom: 0px;
  border-radius: 0px !important;
  font-weight: bold;
  line-height: 20px;
  margin-bottom: 0px;
  border-left: 0px !important;
  font-size: 14px !important;
  border-radius: 0px 6px 6px 0px !important;
  background-color: rgb(255, 255, 255) !important;
`

const Promotion = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [isLoading, setisLoading] = useState(false)
  const [promotionData, setPromotionData] = useState([{}])
  const [carouselPerorangan, setCarouselPerorangan] = useState(null)
  const [carouselAdsIndex, setCarouselAdsIndex] = useState(0)
  const [search, setSearch] = useState('')

  useEffect(() => {
    setisLoading(true)
    loadPromotionData()

    const loadCarouselPerorangan = async () => {
      const { data } = await PromotionAPI('')
      setCarouselPerorangan(data.data.banners)
    }

    if (carouselPerorangan === null) {
      loadCarouselPerorangan()
    }
  }, [carouselPerorangan])

  const loadPromotionData = async function () {
    const promotionData = await PromotionAPI('')
    setPromotionData(promotionData.data.data)
  }

  return (
    <div>
      <Desktop>
        <div style={{ height: '120px' }}></div>
      </Desktop>
      {/* <div className="carousel-home-section-tab-item"> */}
      <CarouselAds items={carouselPerorangan} type="linking" />
      {/* </div> */}

      <InvestorContainer>
        <div className="p-0 m-0 container-fluid">
          <div className="pt-4 px-3 pb-0">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              <div className="row" style={{marginBottom: '20px'}}>
                <div className="col">
                  <h4>{t('promo_terbaru')}</h4>
                </div>
                
                <div className="col-md-auto">
                 
                  <div className="">
                    <InputTextWrapper className="border-0 shadow-none input-group input-group-lg">
                      <InputTextIcon className="input-group-text">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="#DADADA"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.133 17.559a7.426 7.426 0 115.866-2.872l5.001 5L19.687 21l-5-5a7.393 7.393 0 01-4.554 1.559zm5.57-7.426a5.57 5.57 0 11-11.14 0 5.57 5.57 0 0111.14 0z"
                          ></path>
                        </svg>
                      </InputTextIcon>
                      <InputText
                        onChange={(event) => {
                          setSearch(event.target.value)
                        }}
                        className="form-control"
                        placeholder={t('Silakancarilayanan')}
                      />
                      
                    </InputTextWrapper>
                  </div>
                </div>
              </div>
              
              <div className="row mt-2">
                {promotionData?.item
                  ?.filter((value) => {
                    if (
                      value?.title
                        .toString()
                        .toLowerCase()
                        .includes(search.toLocaleLowerCase())
                    ) {
                      return value
                    }
                  })
                  .map((item) => {
                    const modifiedDate = moment(item.expiredDate).format(
                      'DD MMMM YYYY'
                    )
                    return (
                      <div className="col-lg-4" key={item.id}>
                        <Desktop>
                          <PromotionCard
                            title={item.title}
                            image={item.imageDesktop}
                            description={item.shortDescription}
                            expDate={modifiedDate}
                            redirectUrl={'/promotion/detail/' + item.id}
                          />
                        </Desktop>
                        <Mobile>
                          <PromotionCard
                            title={item.title}
                            image={item.imageMobile}
                            redirectUrl={'/promotion/detail/' + item.id}
                            description={item.shortDescription}
                            expDate={modifiedDate}
                            isMobile
                          />
                        </Mobile>
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
        </div>
      </InvestorContainer>
      <FooterSection currentPage={t('promosi')} />
    </div>
  )
}

export default Promotion
